<template>
<div>
    <div class="form-container ou-donation-form ja-ou-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                      <FormSection title="Donation Amount">
                        <div style="position:relative">
                            <AmountSelector/>                    
                            <ErrorLabel field="amount"  style="text-align:right"/>
                        </div>                    
                    </FormSection>
                    <FormSection v-if="form.amount">
                      <TransactionFee />
                    </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
                </FormSection>  
                                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
            <FormSection title="">
            <FormRow>
              <FormLabel class="control-label">Details of Payment </FormLabel>
            </FormRow>
            <FormRow>
              <FormInput type="textarea" field="custom.Notes" />
            </FormRow>
                <FormRow inline>
                  <FormCol field="custom.subjectCategory" width="half" :showLabel="false">
                    <FormLabel class="control-label">Category: </FormLabel>
                    <FormSelect>
                      <option value="General Donation">General Donation</option>
                      <option value="Large-Print Edition">Large-Print Edition</option>
                      <option value="Archive Project">Archive Project</option>                  
                    </FormSelect>
                  </FormCol>
                </FormRow>            
          </FormSection>
                <FormSection title="Payment Information">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>             
                </FormSection>                
                <FormSection title="" last>             
                  <FormRow>
                      <NewsletterSubscribe text="Sign me up for Jewish Action’s monthly newsletter" />
                </FormRow>    
                </FormSection>
                    <PaymentButton :showAmount="false" btnText="Donate Now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form';
import { defineComponent, watch } from "vue";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup(props) {
    const { getValue, setValue, form } = usePaymentForm();

    return {
      form,
      getValue,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">

::v-deep h2 {
color: var(--Grayscale-Ash, #0E1622);
margin-top: 0px;
margin-bottom: 16px;
font-family: "Oswald";
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 18px; /* 112.5% */
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
label,
::v-deep label {
  font-size: .85em;
  color: #333;
}

.form-container.ou-donation-form.ja-ou-form{
    margin: 10px auto 0px !important;
    box-shadow: none !important;
}
.subscribe__btn {
    display: flex;
    background: #1DA1F2;
    color: white;
    margin-bottom: 20px;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    font-weight: 600;
    gap: 7px;
    cursor:pointer;
    transition: all 0.3s ease-in-out;
    justify-content: center;
}
.subscribe__btn:hover{
      background: #004c7b;
    }
.subscribe__btn svg {
    height: 28px;
}
.subscribe__btn.checked{
      background: #f2f6fd;
    color: #595c5f;
    }

.subscribe__btn.checked svg {
    fill: #595c5f !important;
}

.total__section {
    display: flex;
    max-width: 100%;
    padding: 16px;
    flex-flow: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-radius: 2px;
    background: var(--Secondary-Light, #FFF9ED);
}

.total__section strong {
    color: var(--Grayscale-Ash, #0E1622);

/* Desktop/Headline/H7 */
    font-family: "Oswald";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.total__section__opt {
    color: var(--Secondary-Default, #BD8E5C);
    display: flex;
    gap: 8px;
    align-items: center;
/* Desktop/Text/Label */
    font-family: "Merriweather";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
}

.ja-gift {
  margin-top: 20px;
      padding-top: 12px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.ja-gift-container {
  margin-top: 30px;
}

.total__section__con {
margin-top: 30px;
}
</style>

